import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectIsAutoRefresh } from 'src/app/pages/active-calls/state/system-active-calls/system-active-calls.selectors';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';
import { systemCallDetailsAdded, systemCallDetailsUpdated } from './call-details-hub.actions';
import { CallDetailsHubBase } from './call-details-hub.base';

@Injectable()
export class SystemCallDetailsHubService extends CallDetailsHubBase {
   wireUpHubEvents(): void {
      this.init(this.store.select(selectIsAutoRefresh));
   }

   protected init(selector: Observable<boolean>): void {
      this.autoRefresh$ = selector;

      this.autoRefresh$.pipe(takeUntil(this.destroyed$)).subscribe((isAutoRefresh) => {
         this.ndtHubService.connection.on('AddCallDetail', (callDetail) => {
            if (isAutoRefresh) {
               this.store.dispatch(systemCallDetailsAdded({ callDetail }));
            }
         });

         this.ndtHubService.connection.on('UpdateCallDetail', (callDetail) => {
            if (isAutoRefresh) {
               this.store.dispatch(systemCallDetailsUpdated({ callDetail }));
            }
         });
      });
   }

   constructor(ndtHubService: NdtHubConnectionService, store: Store) {
      super(ndtHubService, store);
   }
}
